<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="6">
        <b-form-group>
          <b-input-group>
            <b-form-input
              type="text"
              placeholder="Search"
              @keyup="filterList"
              v-model="searchString"
            />

            <b-input-group-append>
              <b-input-group-text>
                <i
                  class="fa fa-times appendIcon clickIcon"
                  @click="resetSearch"
                ></i>
              </b-input-group-text>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-radio-group
          class="mr-3"
          id="radiosBtn"
          buttons
          button-variant="outline-primary"
          name="radiosBtn"
          v-model="selectedStatus"
          @change.native="filterList"
        >
          <b-form-radio
            class="mx-0 reportRadios standardizedRadioWidth"
            value="1"
            >Active Only</b-form-radio
          >
          <b-form-radio
            class="mx-0 reportRadios standardizedRadioWidth"
            value="0"
            >Show All</b-form-radio
          >
        </b-form-radio-group>
      </b-col>
      <b-col sm="3">
        <div class="form-group form-actions float-right pb-2">
          <b-button
            class="mr-2"
            type="submit"
            size="md"
            variant="primary"
            @click="newEntity"
          >
            <i class="fa fa-plus"></i>
            New Product
          </b-button>
        </div>
        <div>
          <StyledDialog
            @filterList="filterList"
            :CurrentObject="mySelected"
            EntityType="Product"
          >
            <div slot="header">
              <h2>{{ mySelected.ProductName }}</h2>
            </div>
            <div slot="details">
              <div>{{ mySelected.ProductShortDesc }}</div>
            </div>
            <span slot="entityType">Product</span>
          </StyledDialog>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-table
          @row-clicked="myRowClickHandler"
          :items="filteredObjects"
          :fields="fields"
          hover
          small
          fixed
          caption
          selectable
          select-mode="single"
          responsive="sm"
          selectedVariant="success"
          :current-page="currentPage"
          :per-page="perPage"
        >
          <template slot="Functions" slot-scope="data">
            <i
              v-b-tooltip
              title="Delete"
              class="fa fa-trash-o"
              v-b-modal.modal-2
              @click="SetItemToDelete(data.item)"
            ></i>
          </template>
        </b-table>

        <nav v-show="isNavVisible">
          <b-pagination
            :per-page="perPage"
            :total-rows="totalRows"
            v-model="currentPage"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          />
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import cTable from "@/views/base/Table.vue";
//import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
//import MyBaseTable from "@/components/base/MyBaseTable.vue";
import StyledDialog from "@/components/dialogs/StyledModal.vue";

export default {
  name: "ProductList",
  data: () => {
    return {
      fields: [
        {
          key: "Functions",
          label: "",
          sortable: false,
          thStyle: "width: 5%;"
        },
        {
          key: "ProductName",
          label: "Product",
          sortable: true,
          thStyle: "width: 20%;"
        },
        {
          key: "ProductSku",
          label: "Sku",
          sortable: true,
          thStyle: "width: 15%;"
        },
        {
          key: "QuantityInStock",
          label: "Available",
          sortable: true,
          thStyle: "width: 10%;"
        },
        {
          key: "ProductShortDesc",
          label: "Description",
          sortable: true,
          thStyle: "width: 35%;"
        },
        {
          key: "Active",
          label: "Active",
          sortable: true,
          thStyle: "width: 15%;"
        }
      ],
      mySelected: {},
      currentPage: 1,
      perPage: 25,
      filteredObjects: [],
      searchString: "",
      selectedStatus: 1
    };
  },
  props: {},
  components: {
    cTable,
    StyledDialog
    //MyBaseTable
  },
  created() {
    this.myLoadComponent();
  },
  computed: {
    totalRows: function() {
      return this.$store.state.product.products.length;
    },
    totalRowsFiltered: function() {
      return this.filteredObjects.length;
    },
    isNavVisible: function() {
      return this.totalRowsFiltered > this.perPage;
    },
    ...mapState(["product", "notification"]),
    ...mapActions("notification", ["add", "remove"])
  },
  // computed: mapState({
  //   users: state => state.n_user.n_users,
  //   items: state => state.n_user.n_users,
  //   itemsArray: state => state.n_user.n_users
  // }),
  updated() {
    this.incrementCount;
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!item.Active) return "table-danger";
    },
    async myLoadComponent() {
      await this.$store.dispatch("product/fetchProducts");
      await this.$store.dispatch("product/fetchProductTags");
      this.filterList();
    },
    myRowClickHandler(record, index) {
      // 'record' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$store
        .dispatch("product/loadProductEdit", record.ProductID)
        .then(() => {
          this.$router.push({ name: "Product" });
        });
    },
    newEntity() {
      this.$store
        .dispatch("product/newProduct", this.createFreshObject())
        .then(() => {
          this.$router.push({ name: "Product" });
          //,
          //params: { id: this.event.id }
        })
        .catch(() => {
          console.log("There was a problem");
          //.dispatch('notification/add', this.event)
        });
    },
    SetItemToDelete(object) {
      this.mySelected = object;
    },
    createFreshObject() {
      return {
        ProductID: -1,
        ProductName: "",
        ProductDesc: "",
        ProductShortDesc: "",
        Active: true
      };
    },
    filterList: function() {
      this.filteredObjects = this.$store.state.product.products
        .filter(
          product =>
            product.ProductName.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            product.ProductSku.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            product.ProductShortDesc.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            product.ProductDesc.toLowerCase().indexOf(
              this.searchString.toLowerCase()
            ) > -1 ||
            String(product.Active)
              .toLowerCase()
              .indexOf(this.searchString.toLowerCase()) > -1
        )
        .filter(
          product =>
            product.Active == this.selectedStatus || this.selectedStatus == 0
        );
    },
    resetSearch: function() {
      this.searchString = "";
      this.filterList();
    }
  }
};
</script>

<style scoped>
.my-tbl-function {
  width: 10% !important;
  color: red;
}
</style>
